import React, { useEffect } from "react";
import { Form, Input, Button, Select, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import * as notificationAction from "../../../../../redux/actions/notification.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const { RangePicker } = DatePicker;
const riderOption = [
  {value: '', label: 'All'},
  {value: 'active', label: 'Active'},
  {value: 'inactive', label: 'Inactive'},
]

const NotificationFilter = (props) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.notificationFilter){
      form.setFieldsValue(props.notificationFilter);
    }
  }, [props.notificationFilter])

  const filterreset = async () => {
    const pageData = {
      "page": 1,
      "limit": 10,
    }
    await props.notificationAction.filterNotificationAction(pageData);
    form.resetFields();
  }

  const filterChange = async (value) => {
    const pageData = {
      ...props.notificationFilter,
      ...value,
      currentPage: 1,
    };
    try {
      await props.notificationAction.filterNotificationAction(pageData);
    } catch {}
  };


  return (
    <Form form={form} className="custom-form" onFinish={props.loading||filterChange} layout="vertical" name="form_in_modal" initialValues={{ modifier: 'public', }}>
      <Form.Item
       name={["date"]}
       label={"Date"}
      >
        <RangePicker
          allowClear
          format="YYYY-MM-DD"
          disabled={props.loading}
        />
      </Form.Item>
      
      <Form.Item
       name={["city"]}
       label={"City"}
      >
        <Input />
      </Form.Item>
      <Form.Item
       name={["mart"]}
       label={"Mart"}
      >
        <Input />
      </Form.Item>
      <Form.Item
       name={["batch"]}
       label={"Batch"}
      >
        <Input />
      </Form.Item>
      <Form.Item
       name={["rider"]}
       label={"Rider"}
      >
        <Select
          style={{minWidth:"150px"}}
          showSearch
          placeholder="Select Option"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={riderOption}
        />
      </Form.Item>
      <Button htmlType="submit" loading={props.loading} disabled>Search <SearchOutlined /></Button>
      <Button onClick={()=>filterreset()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return { 
    notificationFilter: state.NotificationReducer.notificationFilter,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    notificationAction: bindActionCreators(notificationAction, dispatch),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(NotificationFilter);

